// @flow

const baseSpacing = 4;

export const layout = {
  baseSpacing,
};
